import { render, staticRenderFns } from "./DepthStartColumnModal.vue?vue&type=template&id=ff318f4c"
import script from "./DepthStartColumnModal.vue?vue&type=script&lang=js"
export * from "./DepthStartColumnModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports